module.exports = __webpack_public_path__ + "static/media/Entreprise-Construction-Immobiliere-Vaud.36dcfe57.jpg";